import { jwtDecode } from 'jwt-decode';
import { z } from 'zod';

// Zod schema for reset token payload validation
const ResetTokenPayloadSchema = z.object({
  email: z.email(),
  type: z.literal('password_reset'),
  exp: z.number(), // JWT expiration timestamp
  iat: z.number(), // JWT issued at timestamp
});

export type ResetTokenPayload = z.infer<typeof ResetTokenPayloadSchema>;

export const decodeResetTokenJWT = (
  token: string
): ResetTokenPayload | null => {
  try {
    const decoded = jwtDecode(token);

    // Validate the decoded payload against our schema
    const result = ResetTokenPayloadSchema.safeParse(decoded);

    if (!result.success) {
      console.error('Reset token payload validation failed:', result.error);

      return null;
    }

    // Check if token is expired
    const currentTime = Math.floor(Date.now() / 1000);

    if (decoded.exp && decoded.exp < currentTime) {
      console.error('Reset token has expired');

      return null;
    }

    return result.data;
  } catch (error) {
    console.error('Failed to decode reset token JWT:', error);

    return null;
  }
};

export const isResetTokenValid = (token: string): boolean =>
  decodeResetTokenJWT(token) !== null;
